// Lunch ordering is a school-wide feature: an admin enables it and sets the menu,
// every class uses the same options so school-wide counts line up. Choices are
// recorded per student per day on the attendance record (see Attendance.js).

export const DEFAULT_LUNCH_ENTREES = [
  "Hot lunch",
  "Pasta",
  "Bagel w/ butter",
  "Bagel w/ cream cheese",
  "From home",
];

export const DEFAULT_LUNCH_DRINKS = ["Milk", "Chocolate milk", "Juice", "Water"];

// Resolve a school's configured list, falling back to the defaults when unset.
export function resolveEntrees(raw) {
  return Array.isArray(raw) && raw.length ? raw : DEFAULT_LUNCH_ENTREES;
}
export function resolveDrinks(raw) {
  return Array.isArray(raw) && raw.length ? raw : DEFAULT_LUNCH_DRINKS;
}

// Short one-line summary of a lunch choice for display on a chip.
export function lunchSummary(lunch) {
  if (!lunch) return "";
  return [lunch.entree, lunch.drink].filter(Boolean).join(" · ");
}

// Keyword → emoji for friendly option tiles. First match wins, so order from
// most-specific to least. Covers the presets plus common custom items; anything
// unmatched falls back to a generic plate/cup by kind.
const ICON_RULES = [
  [/chocolate/, "🍫"],
  [/milk/, "🥛"],
  [/juice/, "🧃"],
  [/water/, "💧"],
  [/lemonade/, "🍋"],
  [/pizza/, "🍕"],
  [/pasta|spaghetti|noodle|mac/, "🍝"],
  [/bagel/, "🥯"],
  [/sandwich|sub|hoagie|wrap/, "🥪"],
  [/salad/, "🥗"],
  [/burger/, "🍔"],
  [/hot ?dog/, "🌭"],
  [/chicken|nugget|tender/, "🍗"],
  [/taco|burrito|quesadilla/, "🌮"],
  [/soup/, "🥣"],
  [/yogurt|cereal|oatmeal/, "🥣"],
  [/fruit|apple/, "🍎"],
  [/cheese/, "🧀"],
  [/rice/, "🍚"],
  [/from ?home|packed|brought|home/, "🏠"],
  [/hot|lunch/, "🍲"],
];

export function lunchIcon(name, kind = "entree") {
  const n = (name || "").toLowerCase();
  for (const [re, icon] of ICON_RULES) {
    if (re.test(n)) return icon;
  }
  return kind === "drink" ? "🥤" : "🍽️";
}
